// extracted by mini-css-extract-plugin
export var VisitSpecificTimesAddress = "VisitSpecificTimesAddress-module--VisitSpecificTimesAddress--1bfbc";
export var covidLogos = "VisitSpecificTimesAddress-module--covidLogos--8cc07";
export var image = "VisitSpecificTimesAddress-module--image--99f60";
export var textContent = "VisitSpecificTimesAddress-module--textContent--f5519";